import React from "react";

const SmallLoader = ({ size = 16 }) => {
  return (
    <span
      style={{
        width: size,
        height: size,
        border: "2px solid #ddd",
        borderTop: "2px solid #2563eb", // blue
        borderRadius: "50%",
        display: "inline-block",
        animation: "spin 0.8s linear infinite",
      }}
    />
  );
};

export default SmallLoader;
